module.exports = __webpack_public_path__ + "67be1f32100fe29c98240fa1d074aee3.MP3";